import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, PlaneTakeoff, ShieldCheck } from "lucide-react";
import { getUserAccess } from "../utils/authRoles";
import strobeLogo from "../assets/images/strobelogo.svg";

export default function ChoosePortal() {
  const navigate = useNavigate();
  const [access, setAccess] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const next = await getUserAccess();
      if (!mounted) return;
      if (!next.user) {
        navigate("/login", { replace: true });
        return;
      }
      if (!next.isAdmin || !next.isBroker) {
        navigate(next.isAdmin ? "/admin" : "/portal", { replace: true });
        return;
      }
      setAccess(next);
      setLoading(false);
    })();
    return () => {
      mounted = false;
    };
  }, [navigate]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-black/60">Loading access…</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-[#f6f7f9] to-[#eceff3] px-4 py-10 text-[#1A1A1A]">
      <div className="mx-auto max-w-3xl">
        <img src={strobeLogo} alt="Strobe Aviation" className="mb-10 w-48" />
        <div className="rounded-2xl border border-white/15 bg-white/70 p-6 shadow-[0_10px_30px_rgba(0,0,0,0.08)] backdrop-blur-md">
          <div>
            <h1 className="text-3xl font-extrabold tracking-tight">Choose Portal</h1>
            <p className="mt-1 text-sm text-black/60">{access?.user?.email}</p>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
            <Link to="/portal" className="group rounded-xl border border-black/10 bg-white p-5 transition hover:bg-black/[0.03]">
              <PlaneTakeoff className="h-6 w-6 text-[#EB040D]" />
              <h2 className="mt-4 text-lg font-bold">Broker Portal</h2>
              <p className="mt-1 text-sm text-black/60">Submit and manage broker account requests.</p>
            </Link>
            <Link to="/admin" className="group rounded-xl border border-black/10 bg-white p-5 transition hover:bg-black/[0.03]">
              <ShieldCheck className="h-6 w-6 text-[#EB040D]" />
              <h2 className="mt-4 text-lg font-bold">Admin Portal</h2>
              <p className="mt-1 text-sm text-black/60">Manage all Strobe requests and status updates.</p>
            </Link>
          </div>

          <Link to="/" className="mt-6 inline-flex items-center gap-2 text-sm text-black/55 hover:text-black">
            <LayoutDashboard className="h-4 w-4" />
            Back to website
          </Link>
        </div>
      </div>
    </div>
  );
}
